import { createContext } from 'react'
import type { User } from '@/api/types'

/** The authentication state exposed to the whole app. */
export interface AuthState {
  user: User | null
  isLoading: boolean
  isAuthenticated: boolean
  signIn: (email: string, password: string) => Promise<void>
  /** Exchange an Entra ID token for an ARIES session (production SSO). */
  completeOidcSession: (idToken: string) => Promise<void>
  signOut: () => Promise<void>
}

/**
 * The auth context.
 *
 * It lives in its own module so that the provider file exports only a
 * component and the hook file exports only a hook — which keeps React Fast
 * Refresh working across the app.
 */
export const AuthContext = createContext<AuthState | null>(null)
